import React from 'react'

export default function Footer() {
    return (
        <section className="text-center">
            <h2 className="text-[36px]">Anything else? Get in touch.</h2>
            <p className="text-[17px]">
                <strong>Just email</strong> <a href="mailto:hey@posthog.com">hey@posthog.com</a> and we’ll get back to
                you in a jiffy.
            </p>
        </section>
    )
}
